
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { applyCSP, setupCSPReporting } from './lib/csp'
import initMobileScrollFix from './utils/mobile-scroll-fix'
import { setupSmartPrefetch } from './utils/route-prefetch'

// Apply Content Security Policy and setup violation reporting
applyCSP();
setupCSPReporting();

// Initialize mobile scroll fixes
initMobileScrollFix();

// Setup smart route prefetching for faster navigation
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    setupSmartPrefetch();
  });
}

import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";

createRoot(document.getElementById("root")!).render(
  <AuthProvider>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </AuthProvider>
);

// Capacitor and PWA compatibility
const setupApp = async () => {
  // Register service worker for PWA functionality
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  }

  // Initialize Capacitor if available
  if (window.Capacitor) {
    const { Capacitor } = await import('@capacitor/core');
    
    if (Capacitor.isNativePlatform()) {
      console.log('Running on native platform:', Capacitor.getPlatform());
      
      // Import and initialize plugins
      const { StatusBar } = await import('@capacitor/status-bar');
      const { SplashScreen } = await import('@capacitor/splash-screen');
      
      // Configure status bar
      if (Capacitor.isPluginAvailable('StatusBar')) {
        const { Style } = await import('@capacitor/status-bar');
        await StatusBar.setStyle({ style: Style.Dark });
        await StatusBar.setBackgroundColor({ color: '#0f172a' });
      }
      
      // Wait for critical resources to load before hiding splash (2 seconds for better branding)
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Hide splash screen with smooth fade
      if (Capacitor.isPluginAvailable('SplashScreen')) {
        await SplashScreen.hide({
          fadeOutDuration: 300
        });
      }
    }
  }
};

setupApp();
